import React, { useContext } from 'react';
import { Box, Optional } from '@honda-canada/design-system-react';

import FooterContext from '../service/FooterContext';
import MenuMainDSRAccordion from './MenuMainDSRAccordion';
import MenuMainHeaderAccordion from './MenuMainHeaderAccordion';
import themeStyles from '../Footer.styles';
import { variant4 as footerVariant4, variant5 as footerVariant5 } from '../service/constants';
import { variant6 as headerVariant6, variant7 as headerVariant7 } from '../../Header/service/constants';

const MainContainer = themeStyles.apply(Box, 'MainContainer');

export const variantFooterHeaderMap = {
  [footerVariant4]: headerVariant6,
  [footerVariant5]: headerVariant7,
};

const MenuMain = () => {
  const { variant } = useContext(FooterContext);
  const headerVariant = variantFooterHeaderMap[variant];

  return (
    <MainContainer>
      <Optional when={!headerVariant}>
        <MenuMainDSRAccordion />
      </Optional>
      <Optional when={!!headerVariant}>
        <MenuMainHeaderAccordion variant={headerVariant} />
      </Optional>
    </MainContainer>
  );
};

export default MenuMain;
